import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import App from './App.vue'
import Site from './assets/js/site.js'
import router from './router'
import store from './store'
Vue.prototype.$http = axios;


import "./assets/js/ployfill"; // 注意文件路径


// import uploader from 'vue-simple-uploader';
// Vue.use(uploader);

Vue.use(VueAxios, axios);

// import Vant, { Lazyload } from 'vant'
// import 'vant/lib/index.css'
// Vue.use(Vant)
// Vue.use(Lazyload);


// 原图: https://xz-test.giant.com.cn/file/2024-11/wallhaven_63fa906f0d27460ebefc6535d2a96af3.png
// 小图: https://xz-test.giant.com.cn/small/2024-11/172913158695962.jpg_e401f70f1a7d4b2aa0dcf77a4ea83c66.jpg
// 中图: https://xz-test.giant.com.cn/big/2024-11/wallhaven_63fa906f0d27460ebefc6535d2a96af3.png


if (window.location.host == 'xz.giant.com.cn') { 
  Vue.prototype.$url = "https://xz.giant.com.cn/web/#/out?id=" // 复制分享链接
  Vue.prototype.$downurl = "https://xz.giant.com.cn/cloudDriver" // 
  Vue.prototype.$lookfile = "https://xz.giant.com.cn" // 
  Vue.prototype.$avatarimg = "https://chat.giant.com.cn" //
} else {
  Vue.prototype.$url = "https://xz-test.giant.com.cn/user/#/out?id=" // 复制分享链接
  Vue.prototype.$downurl = "https://xz-test.giant.com.cn/cloudDriver" // 
  Vue.prototype.$lookfile = "https://xz-test.giant.com.cn" // 
  Vue.prototype.$avatarimg = "https://chat.giant.com.cn" //
}

import Button from "@/components/Button.vue"
import Card from "@/components/Card/index.vue"
import Dialog from "@/components/Dialog.vue"
import Fileicon from "@/components/file_icon.vue"
import TableList from "@/components/Table/index.vue"
import Topuserinfo from "@/components/Topuserinfo/index.vue"
import VideoJs from '@/components/VideoJs.vue'

Vue.component('Topuserinfo', Topuserinfo)
Vue.component('but-list', Button)
Vue.component('card-list', Card)
Vue.component('table-list', TableList)
Vue.component('Dialog', Dialog)
Vue.component('Fileicon', Fileicon)
Vue.component('VideoJs', VideoJs)


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)


import "@/assets/css/index.css"
import "@/assets/icon/iconfont.css"

Vue.use(Site);

// 表情
// import emojiRegex from 'emoji-regex'; //npm install emoji-regex
// Vue.directive('clearEmoij', {
//   bind(el, binding, vnode, oldVnode) {
//     const regex = emojiRegex()
//     const obj = el.querySelectorAll('.el-input__inner,.el-textarea__inner')[0]
//     let zclearNoNum = function (e) {
//       if (e.target.composing) return
//       let match = regex.exec(obj.value) //也可以直接用正则表达式判断
//       if (match) {
//         /*for (let i=0;i<match.length;i++) {
//           obj.value = obj.value.replace(match[i],"");
//         }*/
//         obj.value = obj.value.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, "")
//         zclearNoNum(e)
//       }
//       // 触发v-model的更新
//       obj.dispatchEvent(new Event('input'))
//     }
//     let zblur = function (e) {
//       zclearNoNum(e)
//       setTimeout(() => {
//         let match = regex.exec(obj.value)
//         if (match) {
//           obj.value = obj.value.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, "")
//           zclearNoNum(e)
//         }
//         // 触发v-model的更新
//         obj.dispatchEvent(new Event('change'))
//       }, 50)
//     }
//     obj.onkeyup = zclearNoNum
//     obj.onblur = zblur

//     function onCompositionStart(e) {
//       e.target.composing = true
//     }
//     function onCompositionEnd(e) {
//       e.target.composing = false
//       obj.dispatchEvent(new Event('input'))
//     }
//     // https://segmentfault.com/a/1190000009246058
//     obj.addEventListener('compositionstart', onCompositionStart)
//     obj.addEventListener('compositionend', onCompositionEnd)
//   },
//   update(el, binding, vnode, oldVnode) { }
// })


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
